import React from "react";

/**
 * Renders a bot name, truncating overly-long lineage chains like
 * `ORB8-G2-V2-2607020101-G2-V1-2607020505-G2-V1-2607032250-G2-V1-2607050317`
 * to `ORB8-G2-V2…G2-V1-2607050317` while keeping the full name in the title
 * tooltip so nothing is lost. Also parses the depth of `-G[digit]-V` chunks
 * and appends a small "gen 5" badge for readability.
 */
export default function BotName({ name, className = "", showDepth = true, maxLen = 32 }) {
  if (!name) return <span className={className}>—</span>;

  const chunks = name.split("-");
  // Depth = number of "G{n}-V{n}" pairs after the first
  const depth = Math.max(0, chunks.filter((c) => /^G\d+$/i.test(c)).length - 1);

  let display = name;
  if (name.length > maxLen && chunks.length > 4) {
    const head = chunks.slice(0, 3).join("-");
    const tail = chunks.slice(-3).join("-");
    display = `${head}…${tail}`;
  }

  return (
    <span title={name} className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className="truncate">{display}</span>
      {showDepth && depth > 0 && (
        <span
          className="text-[9px] mono uppercase tracking-widest px-1.5 py-0.5 rounded-sm border border-[#60A5FA]/30 bg-[#60A5FA]/10 text-[#60A5FA] shrink-0"
          title={`Generation depth ${depth} - ${depth} rounds of mutation`}
        >
          g{depth}
        </span>
      )}
    </span>
  );
}
